import { MerchantProvisionResult } from '@app/domain/models/tpv/merchant.model';
import { ProvisionResponseDto } from '@app/data/dtos/tpv/provision.dto';

/** DTO de respuesta de provisión -> entidad de dominio. */
export function mapProvisionResult(dto: ProvisionResponseDto): MerchantProvisionResult {
  return {
    polipayAccountId: dto.polipay_account_id,
    externalIdMerchant: dto.external_id_merchant,
    status: dto.status,
  };
}
